export const DEFAULT_EXCHANGES = [
  'ADams',
  'BEnson',
  'CAlumet',
  'SUnset',
  'DExter',
  'FRanklin',
  'MUtual',
  'HOlly',
]

export const ACCEPTED_LOW_CHAR_WORDS = new Set([
  'hi',
  'yo',
  'ok',
  'ok?',
  'hey',
  'sup',
  'yes',
  'no',
  'hm',
  'hmm',
  'uh',
  'uhh',
  'oh',
])

export const PHONE_INPUT_ERRORS = [
  'Eh?',
  '…Hello?',
  'The line crackles.',
  'Speak up.',
  'Say that again?',
  'Just static.',
  'The receiver hisses.',
  'Nothing but silence.',
]
